
import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
// import LessonDialog from '@/components-business/lesson-dialog.vue';

const lessonDialogModule = namespace('lessonDialog');
@Component({
  components: {
    // LessonDialog,
  },
})
export default class ClassType extends Vue {
  @Prop() classTypeList!: []

  @lessonDialogModule.Action('getLessons') getLessons: any

  @lessonDialogModule.Mutation('updateCurrentClass') updateCurrentClass: any

  @lessonDialogModule.Mutation('updateVisible') updateVisible: any

  labelResource: any = {
    1: '自研',
    2: '三阶课',
    3: '短线课',
    4: '公开课',
    5: '双师',
    6: 'AI',
    7: '超级课件',
  }

  private handleShowLessonDialog(classType: any) {
    const data = {
      businessId: classType.id,
      type: 2, // 类型：1,班级;2,班型
      newDiyFlag: classType.newDiyFlag, // 新老diy 0老diy   1新diy
    };
    const currentClass = {
      ...classType,
      businessId: classType.id,
      type: 2,
      classTypeId: classType.id,
    };
    Promise.resolve(this.getLessons(data)).then(() => {
      this.updateCurrentClass(currentClass);
      this.updateVisible(true);
    });
  }
}
